import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { store } from "@/lib/storage";
import PremiumWelcome from "@/components/PremiumWelcome";
import { Loader2 } from "lucide-react";

export default function PaymentSuccess() {
  const loc = useLocation();
  const nav = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "polling", tries: 0 });
  const tries = useRef(0);

  useEffect(() => {
    const sid = new URLSearchParams(loc.search).get("session_id");
    if (!sid) { setState({ status: "error" }); return; }
    let cancelled = false;
    async function poll() {
      if (cancelled) return;
      tries.current += 1;
      try {
        const { data } = await api.get(`/subscription/session/${sid}`);
        if (data.payment_status === "paid") {
          await refresh();
          // Réinitialise le flag pour rejouer l'animation à chaque activation
          store.setPremiumWelcomeSeen(false);
          setState({ status: "paid" });
          return;
        }
      } catch (e) { console.warn("Vérification du paiement en attente :", e?.message); }
      if (tries.current >= 15) { setState({ status: "timeout" }); return; }
      setTimeout(poll, 2000);
    }
    poll();
    return () => { cancelled = true; };
  }, [loc.search, refresh]);

  // Écran Bienvenue Premium plein écran dès confirmation
  if (state.status === "paid") {
    return <PremiumWelcome />;
  }

  return (
    <div className="animate-fade-in pt-10 text-center" data-testid="payment-success-page">
      {state.status === "polling" && (
        <>
          <Loader2 size={48} className="mx-auto text-[color:var(--sauge-light)] animate-spin" />
          <h1 className="mt-6 font-serif text-2xl text-[color:var(--ivoire)]">Confirmation du paiement…</h1>
          <p className="mt-2 text-sm text-[color:var(--ivoire-muted)]">Cette vérification passe par le serveur, pas seulement par cette page.</p>
        </>
      )}
      {(state.status === "timeout" || state.status === "error") && (
        <>
          <h1 className="font-serif text-2xl text-[color:var(--ivoire)]">Vérification en attente</h1>
          <p className="mt-3 text-sm text-[color:var(--ivoire-muted)] max-w-sm mx-auto">
            Nous n'avons pas encore reçu la confirmation de Stripe. Votre accès Premium sera activé automatiquement dès réception du webhook.
          </p>
          <button data-testid="success-back" onClick={() => nav("/reglages")} className="mt-8 w-full h-14 rounded-2xl border border-[color:var(--border)] text-[color:var(--ivoire)]">
            Voir mon abonnement
          </button>
        </>
      )}
    </div>
  );
}
